const NAMESPACE = "advancedESignatureCapsuleTable";

const KEYS = {
    manageRequestButtonLabel: "manageRequestButtonLabel",
    discardButtonLabel: "discardButtonLabel",
    createdTimestampHeader: "createdTimestampHeader",
    envelopeNameHeader: "envelopeNameHeader",
    signatureTypeHeader: "signatureTypeHeader",
    statusTimestampHeader: "statusTimestampHeader",
    statusHeader: "statusHeader",
    emptyTableText: "emptyTableText",
    manageRequestTitle: "manageRequestTitle",
    discardEnvelopeTitle: "discardEnvelopeTitle",
    discardEnvelopeMessage: "discardEnvelopeMessage",
    voidLoadingText: "voidLoadingText",
    resendLoadingText: "resendLoadingText"
};

const MESSAGES = {
    [KEYS.manageRequestButtonLabel]: {
        value: "Manage Request",
        comment: "Label for button to manage eSignature requests"
    },
    [KEYS.discardButtonLabel]: {
        value: "Discard Envelope",
        comment: "Label for button to discard a wet sign envelope"
    },
    [KEYS.createdTimestampHeader]: {
        value: "Created Timestamp",
        comment: "Header for the creation timestamp column"
    },
    [KEYS.envelopeNameHeader]: {
        value: "Envelope Name",
        comment: "Header for the envelope name column"
    },
    [KEYS.signatureTypeHeader]: {
        value: "Signature Type",
        comment: "Header for the signature type column"
    },
    [KEYS.statusTimestampHeader]: {
        value: "Status Timestamp",
        comment: "Header for the status timestamp column"
    },
    [KEYS.statusHeader]: {
        value: "Status",
        comment: "Header for the status column"
    },
    [KEYS.emptyTableText]: {
        value: "There are no eSignature Envelopes for this project.",
        comment: "Placeholder text when there are no Envelopes in a project"
    },
    [KEYS.manageRequestTitle]: {
        value: "Manage eSignature Request",
        comment: "Title for the manage eSignature request dialog box"
    },
    [KEYS.discardEnvelopeTitle]: {
        value: 'Discard "{envelopeName}"?',
        comment: "Title for discard eSignature envelope dialog"
    },
    [KEYS.discardEnvelopeMessage]: {
        value: "Are you sure you want to discard this Envelope?",
        comment: "Confirmation message for discarding a wet sign Envelope"
    },
    [KEYS.voidLoadingText]: {
        value: "Voiding...",
        comment: "Loading text when voiding an envelope"
    },
    [KEYS.resendLoadingText]: {
        value: "Resending...",
        comment: "Loading text when resending envelope notifications"
    }
};

export { NAMESPACE, KEYS, MESSAGES };
